/* eslint-disable react-native/no-inline-styles */
import React from "react";
import { Tooltip } from "react-tooltip";

const KeyInfoDetails = ({
  pdpData,
  pdpPropertyFees,
  emd,
  status,
  getbidcenterdata,
  isFcOnlineFlag,
}) => {
  // const tooltipRefBid = useRef(null);
  // const tooltipRefEarnest = useRef(null);
  // const [showBidDeposit, setBidDepositShow] = useState(false);
  // const [showBuyer, setBuyerShow] = useState(false);
  // const [showEarnestToolTip, setEarnestToolTipShow] = useState(false);
  // const [earnestSelectedIndex, setEarnestSelectedIndex] = useState();
  // const [showTechnology, setTechnology] = useState(false);
  // const [showBuyerPay, setBuyerPay] = useState(false);

  // const tooltipRefTechFee = useRef(null);
  // const tooltipRef = useRef(null);

  const propertyDetails = pdpData?.propertyDetails || {};
  const { propertyId, detailedAttributes, commonAttributes } = propertyDetails;

  const propertySpecialDetails = pdpData?.propertySpecialDetails || {};
  const {
    pdpEnabledFeatures,
    webTransactionFee,
    shortSaleFlag,
    buyerAgentCommissionPercent,
    buyerAgentCommissionAmount,
    buyerAgentCommissionString,
    hideBuyerAgentCommissionFlag,
  } = propertySpecialDetails;
  const { listingType } = pdpData?.listingDetail || {};
  const { propCategory } = commonAttributes || {};

  const getFormatPrice = (amnt) => {
    if (amnt?.length === 0 || isNaN(amnt)) {
      return "";
    }
    return amnt?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  };

  const buyerAgentCommissionText =
    buyerAgentCommissionString?.length > 0 &&
    buyerAgentCommissionString !== null
      ? buyerAgentCommissionString
      : buyerAgentCommissionPercent > 0 &&
          buyerAgentCommissionAmount !== 0 &&
          buyerAgentCommissionPercent !== null &&
          buyerAgentCommissionAmount !== null
        ? "Greater of " +
          buyerAgentCommissionPercent +
          "% of sale price or $" +
          getFormatPrice(buyerAgentCommissionAmount) +
          "."
        : buyerAgentCommissionAmount !== 0 &&
            buyerAgentCommissionAmount !== null
          ? "$" + getFormatPrice(buyerAgentCommissionAmount)
          : buyerAgentCommissionPercent > 0
            ? buyerAgentCommissionPercent + "%"
            : "Not Offered";
  const { isPrelistAsset, apnTaxId, isAllowedPreSale } = detailedAttributes;
  const hasAPN = apnTaxId !== "";
  const isPreviewProperty = isAllowedPreSale !== null;
  const showBid =
    isFcOnlineFlag === "Y" ||
    (propCategory !== "FORECLOSURE" &&
      isPrelistAsset !== "PREVIEW" &&
      listingType !== "TRNL");
  const getBuyersPremimum = () => {
    if (pdpEnabledFeatures?.includes("SELLER")) {
      return pdpPropertyFees?.sellerPremiumText;
    } else if (
      pdpData?.revisedBuyerPremium !== undefined &&
      pdpData?.revisedBuyerPremiumPercentage
    ) {
      if (pdpData?.revisedBuyerPremium && pdpData?.revisedBuyerPremium <= 0) {
        return pdpPropertyFees?.buyerPremiumTxtAmt0;
      } else if (
        pdpData?.revisedBuyerPremiumPercentage &&
        pdpData?.revisedBuyerPremiumPercentage <= 0
      ) {
        return pdpPropertyFees?.buyerPremiumTxtPer0;
      } else {
        return pdpPropertyFees?.buyerPremiumDetails
          .replace("###BP_PER###", pdpData?.revisedBuyerPremiumPercentage)
          .replace(
            "###BP_AMOUNT###",
            getFormatPrice(pdpData?.revisedBuyerPremium),
          );
      }
    }
    return "";
  };

  const showBuyersPremimum = getBuyersPremimum() !== "";

  var showTechnologyFee =
    !pdpEnabledFeatures?.includes("SELLER") &&
    (webTransactionFee?.replace("$", "").length === 0 ||
      webTransactionFee === "$0")
      ? false
      : true;
  // const showTechnologyFee = trxFee ? false : true;

  const showEarnest =
    shortSaleFlag === "N" &&
    propCategory !== "FORECLOSURE" &&
    isPrelistAsset !== "PREVIEW";

  return (
    <div>
      {showBuyersPremimum && listingType === "AUCN" && (
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "8px",
          }}
        >
          <Tooltip
            id="Buyer_pays_tooltip"
            style={{ fontSize: 11, width: 300 }}
          />

          <span style={{ marginRight: "8px", fontSize: 25, color: "black" }}>
            •
          </span>
          <p className="propertyFeeTextDescription" tabIndex="0">
            {propCategory === "COMMERCIAL"
              ? "Transaction Fee:"
              : " Buyer's premium:"}{" "}
            {getBuyersPremimum() + " "}
            <span
              style={{ cursor: "pointer" }}
              data-tooltip-id="Buyer_pays_tooltip"
              data-tooltip-content={pdpPropertyFees?.buyerPremiumTooltip}
            >
              (
              <span
                style={{
                  textDecoration: "underline dotted",
                  cursor: "pointer",
                }}
              >
                Buyer Pays at Closing)
              </span>
            </span>
          </p>
        </div>
      )}
      {showTechnologyFee && (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "8px",
            }}
          >
            <Tooltip
              id="technologyFeeToolTip"
              style={{ fontSize: 11, width: 300 }}
            />
            <span style={{ marginRight: "8px", fontSize: 25, color: "black" }}>
              •
            </span>

            <p className="propertyFeeTextDescription" tabIndex="0">
              Technology Fees: {webTransactionFee}
              <span
                style={{ textDecorationLine: "", cursor: "pointer" }}
                data-tooltip-id="technologyFeeToolTip"
                data-tooltip-content={pdpPropertyFees.technologyFeeTooltip}
              >
                {" "}
                (
                <span
                  style={{
                    textDecoration: "underline dotted",
                    cursor: "pointer",
                  }}
                >
                  Buyer Pays at Closing)
                </span>
              </span>
            </p>
          </div>
        </div>
      )}
      {showEarnest && emd && (
        <div>
          {emd.map((item, index) => {
            return (
              <div key={item.id || item.financeType || index}>
                <Tooltip id="emdToolTip" style={{ fontSize: 11, width: 300 }} />

                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginBottom: "8px",
                  }}
                >
                  <span
                    style={{ marginRight: "8px", fontSize: 25, color: "black" }}
                  >
                    •
                  </span>
                  {item.financeType === "CASH" ? (
                    <div className="row">
                      <p className="propertyFeeTextDescription" tabIndex="0">
                        {item.financeType}- {item.depositEarnestMoney}{" "}
                        {/* (Buyer Pays at Offer Selection) */}
                      </p>
                    </div>
                  ) : (
                    <p className="propertyFeeTextDescription" tabIndex="0">
                      {item.financeType}: {item.depositEarnestMoney}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
          <Tooltip id="emdToolTip" style={{ fontSize: 11, width: 300 }} />

          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "8px",
            }}
          >
            {/* <span style={{ marginRight: '8px', fontSize: 25, color: 'black' }}></span> */}
            <p
              style={{ cursor: "pointer", paddingLeft: 14 }}
              data-tooltip-id="emdToolTip"
              data-tooltip-content={pdpPropertyFees?.earnestMoneyTooltip}
              tabIndex="0"
            >
              (
              <span
                style={{
                  textDecoration: "underline dotted",
                  cursor: "pointer",
                  color: "#000000",
                }}
              >
                Buyer Pays Once Purchase & Sale Agreement is Fully Executed)
              </span>
            </p>
          </div>
        </div>
      )}
      {/* {getbidcenterdata &&
        !getbidcenterdata?.clientCodeRestrictedFlag &&
        isFcOnlineFlag !== "Y" && (
          <div notopmargin>
            <p className="propertyFeeTextDescription">
              Note: <p className="propertyFeeTextDescription">{pdpPropertyFees.noteText}</p>
            </p>
          </div>
        )} */}
      {hideBuyerAgentCommissionFlag !== 'Y' &&
      buyerAgentCommissionText &&
      buyerAgentCommissionText !== "Not Offered" &&
      buyerAgentCommissionText !== undefined &&
      buyerAgentCommissionText !== "$" &&
      buyerAgentCommissionText?.length > 0 ? (
        <div style={{ flexWrap: "wrap", paddingRight: 20, marginBottom: 10 }}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "8px",
            }}
          >
            <span style={{ marginRight: "8px", fontSize: 25, color: "black" }}>
              •
            </span>
            <p className="propertyFeeTextDescription" tabIndex="0">
              Buyer's Agent Commission:{" "}
              <p className="propertyFeeTextDescription">
                {buyerAgentCommissionText} (Seller Pays at Closing)
              </p>
            </p>
          </div>
        </div>
      ) : pdpData?.propertySpecialDetails?.brokerCoOpSellerCategoryFlag ===
        "Y" && hideBuyerAgentCommissionFlag !== 'Y' ? (
        <div style={{ flexWrap: "wrap", paddingRight: 20, marginBottom: 10 }}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "8px",
            }}
          >
            <span style={{ marginRight: "8px", fontSize: 25, color: "black" }}>
              •
            </span>

            <p className="propertyFeeTextDescription" tabIndex="0">
              Buyer's Agent Commission:{" Not Offered"}
            </p>
          </div>
        </div>
      ) : null}

      {listingType === "TRNL" ? (
        <div style={{ marginTop: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "8px",
            }}
          >
            <span style={{ marginRight: "8px", fontSize: 25, color: "black" }}>
              •
            </span>
            <p className="propertyFeeTextDescription" tabIndex="0">
              All offers must be submitted through Hubzu.com. Offers sent via
              email and fax will not be considered.
            </p>
          </div>
        </div>
      ) : (
        <div style={{ marginTop: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "8px",
            }}
          >
            <span style={{ marginRight: "8px", fontSize: 25, color: "black" }}>
              •
            </span>
            <p className="propertyFeeTextDescription" tabIndex="0">
              All bids must be submitted through Hubzu.com. Bids sent via email
              and fax will not be considered.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default KeyInfoDetails;
